import { faker } from '@faker-js/faker'

type Status = 'Adesão aceita' | 'Comunicação Enviada' | 'Adesão reprovada' | 'Comunicação em andamento'
const statusOptions: Status[] = ['Adesão aceita', 'Comunicação Enviada', 'Adesão reprovada', 'Comunicação em andamento']

const produtos: string[] = [
  'Bradesco Nacional Flex',
  'Bradesco Premium',
  'Bradesco Ouro',
  'Bradesco Classic',
  'Bradesco Universitário',
  'Bradesco Internacional',
  'Bradesco Platinum',
]

const generateRandomAdherenceRow = (): any => {
  return {
    Nome: faker.person.firstName(),
    CPF: faker.number.bigInt({ min: 10000000000, max: 99999999999 }).toString(),
    Tipo: 'Titular',
    Data_de_resposta: Math.random() > 0.5 ? faker.date.past().toLocaleDateString('pt-BR') : null,
    Status: statusOptions[Math.floor(Math.random() * statusOptions.length)],
    Produto_Escolhido: Math.random() > 0.5 ? produtos[Math.floor(Math.random() * produtos.length)] : null,
  }
}

const generateRandomAdherenceRows = (quantidade: number): any[] => {
  return Array.from({ length: quantidade }, generateRandomAdherenceRow)
}

export { generateRandomAdherenceRows }
